import Vue from "vue";

const isDateBr = (v) => {
  const value = String(v ?? "").trim();
  if (!value) return false;
  const date = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!date) return false;
  const day = parseInt(date[1], 10);
  const month = parseInt(date[2], 10) - 1;
  const year = parseInt(date[3], 10);
  const dateFormatted = new Date(year, month, day);
  return (
    dateFormatted.getFullYear() === year &&
    dateFormatted.getMonth() === month &&
    dateFormatted.getDate() === day
  );
};

Vue.prototype.$rules = {
  required: [(v) => !!String(v ?? "").trim() || "Campo obrigatório"],
  email: [(v) => !v || /.+@.+/.test(v) || "E-mail inválido"],
  min10Text: [
    (v) => String(v ?? "").trim().length >= 10 || "Mínimo de 10 caracteres",
  ],
  dateBr: [(v) => isDateBr(v) || "Data inválida (dd/mm/aaaa)"],
  confirmPassword(password1, password2) {
    return [() => password1 === password2 || "Senhas diferentes"];
  },
};
